module.exports = "/_next/static/images/65c8b4d8026edd3a4d69b0675bf20d1a-Nubank_HickDuarte_55193_md.jpg.webp";